module.exports = __webpack_public_path__ + "img/sc-2p-blank.e5f2c652.png";